module.exports = __webpack_public_path__ + "img/community-norm_ar.f84cb19c.png";